export default {
  header: "Update Patient Weight",
};
